export default __webpack_public_path__ + "static/media/docx.a515113d.svg";